module.exports = __webpack_public_path__ + "static/media/pitch.6b60f3fd.svg";